import * as React from "react";
import Component from "../../AbstractComponent";
import { ChargeInterface } from "../../../Entity/Entities/Charge/ChargeInterface";
import { Person } from "../../../Entity/Entities/Person/Person";
import Time from "../../../Time/Time";
import { Attachment } from "../../Partials/Attachment/Attachment";
import Charge2State from "../../Partials/Charge/Charge2State";
import Button from '@material-ui/core/Button';
import Constants from "../../../Action/Constants";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { DatePickerComponent } from "../DatePicker/DatePickerComponent";
// import CircularProgress from '@material-ui/core/CircularProgress';
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import Formatter from "../../../Localization/Formatter";
import Store from "../../../Store/Store";
import CurrencyContainer from "../../../Currency/CurrencyContainer";

export default class Charge2DetailsReadonly extends Component {
  public state = {
    isChangeStatementPeriodPopupOpen: false,
    newStatementPeriod: this.props.charge?.firstDate,
    isSaving: false,
  };

  constructor(public props) {
    super(props);
  }

  public getReadonlyReason = (charge: ChargeInterface) => {
    if (charge?.removed) {
      return this.trans("charge-summary-readonly/removed");
    } else if (charge?.isLocked && charge?.financialStatement?.locked) {
      return this.trans("charge-summary-readonly/islocked");
    } else if (charge?.isInvoice) {
      return this.trans("charge-summary-readonly/isinvoice");
    } else if (charge?.isSettle) {
      return this.trans("charge-summary-readonly/wassettled");
    } else if (charge?.hasSavingsType || charge?.isReferencedToSavings) {
      return this.trans("charge-summary-readonly/withsavings");
    } else if (charge?.hasPayoutType) {
      return this.trans("charge-summary-readonly/payout");
    } else if (charge?.hasSettlementType) {
      return this.trans("charge-summary-readonly/settlement");
    } else if (charge?.hasRefundType) {
      return this.trans("charge-summary-readonly/refund");
    } else if (charge?.isPaidDirectlyToOwner) {
      return this.trans("charge-summary-readonly/ispaiddirectlytoowner");
    } else if (charge?.isCredited) {
      return this.trans("event-charge-credited");
    }
  }


  public renderRemovedState = () => {
    return this.trans("charge-summary-state/removed").toLowerCase();
  }

  public renderUnpaidState = () => {
    return this.props.isSettled ? this.trans("payment-summary-state/unused").toUpperCase() : this.trans("charge-summary-state/unpaid").toLowerCase();
  }

  public renderPaidState = () => {
    return this.props.isSettled ? this.trans("status-used").toUpperCase() : this.trans("charge-summary-state/paid").toLowerCase();
  }

  public renderReceivedState = () => {
    return this.props.isSettled ? this.trans("status-used").toLowerCase() : this.trans("charge-summary-state/received").toLowerCase();
  }

  public renderPartialPaidState = (charge: ChargeInterface) => {
    // return <div style={{whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden"}}>{charge?.isReceivable ? this.trans("charge-summary-state/remainingtoreceive") : this.trans("charge-summary-state/remainingtopay")} <span style={{ color: "#ababab" }}>{charge?.currency?.getIso()} {this.formatter.formatNumber(charge?.amountRemaining)}</span></div>
    return <div style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" }}>{this.props.isSettled ? this.trans("status-used") : charge?.isReceivable ? this.trans("charge-summary-state/remainingtoreceive") : this.trans("charge-summary-state/remainingtopay")} <span style={{ color: "#ababab" }}>{charge?.currency?.getIso()} {this.props.isSettled ? this.formatter.formatNumber(this.props.settlementAmount) : this.formatter.formatNumber(charge?.amountRemaining)}</span></div>
  }

  public renderStatus = (charge: ChargeInterface) => {
    if (charge?.amount === 0) {
      return
    }

    if (charge?.removed) {
      return this.renderRemovedState();
    }

    if (charge?.isFullyPaid()) {
      if (charge?.isReceivable) {
        return this.renderReceivedState();
      }

      return this.renderPaidState();
    }

    if (charge?.amountPaid === 0) {
      return this.renderUnpaidState();
    }

    if (charge?.amountRemaining > 0) {
      return this.renderPartialPaidState(charge);
    }
  }
  public updateStatementPeriod = (charge: ChargeInterface) => {
    this.setState({
      isSaving: true,
    })
    this.saving(() => {
      return this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_UPDATE_START,
        payload: {
          chargeId: charge?.id,
          charge: {
            firstDate: Time.formatOrNull(this.state.newStatementPeriod)
          }
        },
        onSuccess: () => {
          this.setState({
            isSaving: false,
            isChangeStatementPeriodPopupOpen: false
          })
          return this.props.initializePage(charge.id)
        },
        onError: () => {
          this.setState({
            isSaving: false
          })
        }
      });
    });
  }

  public selectDate = (date: Date, identifier: string): void => {
    this.setState({
      [identifier]: date,
      hasModifiedData: true
    });
  }

  public renderStatementPeriodDialogContent = () => {
    return (
      <div>
        <p>
          {this.trans("page/chargeupdate-dialog/updatestatementperiod-hint")}
        </p>

        <DatePickerComponent
          {...this.props}
          id="firstDateOfStatementPeriodForPayment"
          name="firstDateOfStatementPeriodForPayment"
          className="scroll-to-firstDateOfStatementPeriodForPayment"
          label={this.trans("section/payment-field/forperiod-label")}
          initialDate={this.state.newStatementPeriod}
          onChange={date => this.selectDate(date, "newStatementPeriod")}
          clearButton={false}
          openTo={"month"}
          views={["year", "month"]}
          disableKeyboard={true}
          error={this.getErrorFor("firstDateOfStatementPeriodForPayment")}
        />
      </div>
    );
  }
  public render() {
    const charge: ChargeInterface = this.props.charge;
    // console.log("🚀 ~ Charge2DetailsReadonly ~ charge:", `/app/charge/update/${charge?.linkedCharge.id}/`, `/app/charge/update/${this.props?.relatedCharge?.id}/`)
    const hasDuplicateSavingsLinks = () => {
      if (charge && charge.linkedCharge && charge.linkedCharge.id && this.props && this.props?.relatedCharge && this.props?.relatedCharge?.id) {
        return `/app/charge/update/${charge?.linkedCharge.id}/` === `/app/charge/update/${this.props?.relatedCharge?.id}/`
      }
      return false
    }
    return (
      <div className="charge-details-readonly">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
          }}
        >
          <div className="title">
            {charge?.isReceivable
              ? this.trans('charge-summary-title/receivable')
              : this.trans('charge-summary-title/payable')}
          </div>
          <div className="date">
            {charge &&
              charge.financialStatement &&
              charge.financialStatement.locked
              ? this.formatter.formatDate(charge.financialStatement.updatedAt)
              : this.formatter.formatDate(charge?.orderDate)}
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'baseline',
          }}
        >
          <div className="counterparty">
            {`${charge?.name || ''} ${charge?.hasSavingsType
              ? `(${this.trans('charge/payment-summary-title/savings')})`
              : ''
              }`}
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-end',
            }}
          >
            <div className="currency">{charge?.currency?.getIso()}</div>
            <div className="amount">
              {!this.props.newCardStyles
                ? this.formatter.formatNumber(charge?.amount)
                : this.formatter.formatNumber(
                  charge?.amountPaidFromPayments(charge?.paymentIds)
                )}
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <table>
            {this.props.newCardStyles && (
              <tr>
                <td className="align-left first-column">
                  {this.trans('charge-summary-state/status')}
                </td>
                <td className="align-left">{this.renderStatus(charge)}</td>
              </tr>
            )}
            <tr>
              <td className="align-left first-column">
                {`${this.trans('object')}:`}
              </td>
              <td className="align-left">
                <div
                  className="link-to-entity"
                  onClick={() =>
                    this.redirect(
                      `/app/${charge?.relatedEntity.nameForUrl}/update/${charge?.relatedEntity.id}/`
                    )
                  }
                >
                  {charge?.relatedEntity?.displayName}
                </div>
              </td>
            </tr>
            <tr>
              <td className="align-left first-column">
                {`${this.trans('label-counterparty')}:`}
              </td>
              <td className="align-left">
                <div
                  className="link-to-entity"
                  onClick={() =>
                    this.redirect(
                      `/app/${charge?.counterparty instanceof Person
                        ? 'person/update'
                        : 'company/update'
                      }/${charge?.counterparty?.id}`
                    )
                  }
                >
                  {charge?.counterparty?.displayName}
                  {/* Below crazy code inserted by ornatDev. Crazy bacause: (1) ORring 2 arrays is always true and (2) why only present the name of the counterparty for other receivable / other payabel? */}
                  {/*(charge?.linkedPayments || charge?.payments) && (charge?.type?.id === 255 || charge?.type?.id === 254) ? (charge?.linkedPayments[0]?.name || charge?.payments[0]?.name) : charge?.counterparty?.displayName*/}
                </div>
              </td>
            </tr>
            <tr>
              <td className="align-left first-column">
                {`${this.trans('label-type')}:`}
              </td>
              <td className="align-left">
                {this.formatter.checkTranslationType(
                  this.trans(charge?.type?.label, {}, '', charge?.type?.system),
                  charge?.type?.label,
                  charge?.type?.system
                )}
              </td>
            </tr>
            <tr>
              <td className="align-left first-column">
                {`${this.trans('description')}:`}
              </td>

              <td className="align-left">{charge?.description}</td>
            </tr>
            <tr>
              <td className="align-left first-column">
                {this.trans('charge-summary-details/period')}
              </td>
              <td className="align-left">
                {`${Time.formatTwoDatesPeriodForLanguage(
                  charge?.dateOfPeriod,
                  charge?.lastDateOfPeriod
                    ? charge?.lastDateOfPeriod
                    : charge?.lastDate,
                  Store.getConfigurator().getState().app.settings.user.locale.iso,
                )}`}
              </td>
            </tr>
            <tr>
              <td className="align-left first-column">
                {`${this.trans('due-date')}:`}
              </td>
              <td className="align-left">
                {this.formatter.formatDate(charge?.dueDate)}
              </td>
            </tr>
            {!!charge?.ownerFinancialStatementId &&
              charge.ownerId !== this.getAgency().id && (
                <tr>
                  <td className="align-left first-column">
                    {this.trans('charge-summary-details/ownerstatement')}
                  </td>
                  <td className="align-left">
                    <div
                      className="margin-wrapper"
                      style={{ display: 'flex', alignItems: 'center' }}
                    >
                      <div
                        className="link-to-entity"
                        onClick={() =>
                          this.redirect(
                            `/app/owner-statement/update/${charge?.ownerFinancialStatementId}/`
                          )
                        }
                      >
                        {`${Time.useFormatForUserLanguage(charge?.firstDate, Store.getConfigurator().getState().app.settings.user.locale.iso,'MMMM YYYY')}`}
                      </div>
                      {(charge?.isReadonly || charge?.isCredited) &&
                        !charge?.hasPayoutType &&
                        this.props.mainCardPresentation && (
                          <Button
                            color="primary"
                            style={{
                              padding: '4px 10px',
                              marginLeft: '12px',
                              lineHeight: 'normal',
                              whiteSpace: 'nowrap',
                              border: '1px solid',
                            }}
                            onClick={() => {
                              this.setState({
                                isChangeStatementPeriodPopupOpen: true,
                              });
                            }}
                          // style={{marginLeft: "5px"}}
                          >
                            {this.trans(
                              'page/paymentupdate-link/updatestatementperiod'
                            )}
                          </Button>
                        )}
                    </div>
                  </td>
                </tr>
              )}
            {!charge?.hasPayoutType &&
              charge?.ownerId === this.getAgency().id && (
                <tr>
                  <td colSpan={2} style={{ padding: '0', color: '#757575' }}>
                    {this.trans(
                      'charge-summary-details/not-part-of-owner-statement'
                    )}
                  </td>
                </tr>
              )}
            {charge?.isInvoice && charge?.invoiceDate && (
              <tr>
                <td className="align-left first-column">
                  {`${this.trans('section/charge-field/invoicedate-label')}:`}
                </td>
                <td className="align-left">
                  {this.formatter.formatDate(charge?.invoiceDate)}
                </td>
              </tr>
            )}
            {charge?.isInvoice && charge?.invoiceNumber && (
              <tr>
                <td className="align-left first-column">
                  {this.trans('charge-summary-details/invoicenumber')}
                </td>
                <td className="align-left">{charge?.invoiceNumber}</td>
              </tr>
            )}
            {charge?.isInvoice && !charge?.hasPayoutType && (
              <tr>
                <td className="align-left first-column">
                  {this.trans('label-vat')}{' '}
                  {isNaN((charge?.vat / (charge?.amount - charge?.vat)) * 100)
                    ? 0
                    : this.formatter.simpleFormatNumber(
                      Math.round(
                        (charge?.vat / (charge?.amount - charge?.vat)) * 100
                      ),
                      false,
                      false
                    )}
                  %
                </td>
                <td className="align-left">
                  {this.formatter.formatNumber(charge?.vat, charge?.currency)}
                </td>
              </tr>
            )}
            {charge?.isInvoice &&
              charge?.hasPayoutType &&
              charge?.collectiveVat?.map((vat) => {
                return (
                  <tr>
                    <td className="align-left first-column">
                      {this.trans('label-vat')} {vat?.percentage}%
                    </td>
                    <td className="align-left">
                      {this.formatter.formatNumber(
                        vat?.totalVatAmount,
                        charge?.currency
                      )}
                    </td>
                  </tr>
                );
              })}
            {this.props?.relatedCharge && charge.isCredit && (
              <tr>
                <td className="align-left first-column">
                  {this.trans('charge-summary-details/credits')}
                </td>
                <td className="align-left">
                  <span
                    className="link-to-entity"
                    onClick={() =>
                      this.redirect(
                        `/app/charge/update/${this.props?.relatedCharge.id}/`
                      )
                    }
                  >
                    {this.props?.relatedCharge?.displayName}
                  </span>
                </td>
              </tr>
            )}
            {charge?.linkedCharge && (
              <tr>
                <td className="align-left first-column">
                  {this.trans('charge-summary-details/related')}
                </td>
                <td className="align-left">
                  <span
                    className="link-to-entity"
                    onClick={() =>
                      this.redirect(
                        `/app/charge/update/${charge?.linkedCharge.id}/`
                      )
                    }
                  >
                    {this.props?.relatedCharge?.displayName}
                  </span>
                </td>
              </tr>
            )}
            {!hasDuplicateSavingsLinks() && this.props?.relatedCharge && charge?.isReferencedToSavings && (
              <tr>
                <td className="align-left first-column">
                  {this.trans('charge-summary-details/savings')}
                </td>
                <td className="align-left">
                  <span
                    className="link-to-entity"
                    onClick={() =>
                      this.redirect(
                        `/app/charge/update/${this.props?.relatedCharge?.id}/`
                      )
                    }
                  >
                    {this.props?.relatedCharge?.displayName}
                  </span>
                </td>
              </tr>
            )}
            {charge?.isCredited &&
              charge?.creditCharges.length > 0 &&
              charge?.creditCharges.map((charge) => {
                const periodId = Number(charge.period);
                const currencyId = Number(charge.currencyId);
                const description = `${charge.name
                  }, Credit, ${Formatter.formatNumber(
                    charge.amount
                  )} ${CurrencyContainer.pickFromId(currencyId).getIso()}, ${Store.getConfigurator().getState().globalTypes
                    ?.RepeatPeriod?.[periodId].label
                  }`;
                return (
                  <tr>
                    <td className="align-left first-column">
                      {this.trans('charge-summary-details/credits')}
                    </td>
                    <td className="align-left">
                      <span
                        className="link-to-entity"
                        onClick={() =>
                          this.redirect(`/app/charge/update/${charge.id}/`)
                        }
                      >
                        {description}
                      </span>
                    </td>
                  </tr>
                );
              })}
          </table>
          <div style={{ position: 'relative', top: '0px' }}>
            {/* {!this.props.newCardStyles ? */}
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {this.props.showAmountUsed && (
                <span style={{ marginRight: '6px', whiteSpace: 'nowrap' }}>
                  ({' '}
                  {this.props.isSettled
                    ? this.formatter.formatNumber(this.props.settlementAmount)
                    : this.formatter.formatNumber(
                      this.props.linkedPayment?.amountDetails[charge?.id]
                    )}{' '}
                  )
                </span>
              )}
              <Charge2State {...this.props} charge={charge} />
            </div>

            {/* : !charge?.isFullyPaid() && (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ fontSize: "16px" }}>
                    {this.trans("payment").toLowerCase()}
                  </div>
                  <div style={{ marginLeft: "5px", fontSize: "16px" }}>
                    {charge?.currency?.getIso()}
                  </div>
                  <div style={{ marginLeft: "5px", fontSize: "16px" }}>
                    {this.formatter.formatNumber(charge?.amount)}
                  </div>
                </div>
              )} */}
          </div>
        </div>
        {(charge?.isReadonly || charge?.isCredited) &&
          this.props.mainCardPresentation && (
            <div
              className="readonly-reason"
              style={{ flexDirection: 'column' }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <div
                  className="list-label readonly"
                  style={{
                    marginRight: '5px',
                    maxWidth: 'max-content',
                  }}
                >
                  {(charge?.isReadonly || charge?.isCredited) &&
                    this.trans('label-readonly')}
                </div>
                <div style={{ marginTop: '5px' }}>
                  {this.getReadonlyReason(charge)}
                </div>
              </div>
            </div>
          )}
        {/* {
          this.props?.relatedCharge &&
          <div>
            <span
              style={{
                marginRight: "5px",
                maxWidth: "max-content"
              }}
            >
              {this.trans("charge-summary-details/credits")}
            </span>
            <span
              className="link-to-entity"
              onClick={() => this.redirect(`/app/charges/update/${this.props?.relatedCharge.id}/`)}
            >
              {this.props?.relatedCharge.displayName}
            </span>
          </div>


        } */}
        {this.props.mainCardPresentation &&
          !charge?.isCredited &&
          !charge?.isReadonly && (
            <div
              style={{
                marginTop: '10px',
                display: 'flex',
                justifyContent: this.props.unActionButton
                  ? 'space-between'
                  : 'flex-start',
              }}
            >
              <Button
                variant="outlined"
                color="primary"
                onClick={() => {
                  if (typeof this.props.openEditableView === 'function') {
                    this.props.openEditableView();
                  }
                }}
              >
                {this.trans('button-update')}
              </Button>
            </div>
          )}
        {!this.props.mainCardPresentation && (
          <div
            style={{
              marginTop: '10px',
              display: 'flex',
              justifyContent: this.props.unActionButton
                ? 'space-between'
                : 'flex-start',
            }}
          >
            <Button
              variant="outlined"
              color="primary"
              onClick={() => this.redirect(`/app/charge/update/${charge?.id}`)}
            >
              {this.trans('button-open')}
            </Button>
            {this.props.unActionButton}
          </div>
        )}
        {this.props.mainCardPresentation && (
          <div style={{ marginTop: '30px' }}>
            <Attachment
              {...this.props}
              typeOfComponent="shared"
              title={this.trans('attachments-for-charge')}
              amazonFolderName={this.props.amazonFolderName}
              relation="chargeId"
              entity={charge}
              attachments={this.props.attachments}
              onChangeAvatar={(avatar) =>
                (this.refs.EntityAvatar as any) &&
                (this.refs.EntityAvatar as any).change(avatar)
              }
              onLastImageDeleted={() =>
                (this.refs.EntityAvatar as any) &&
                (this.refs.EntityAvatar as any).revert()
              }
              disabled={charge?.removed}
              isCardView={true}
            />
          </div>
        )}
        <PromptDialog
          {...this.props}
          title={this.trans(
            'page/paymentupdate-dialog/updatestatementperiod-title'
          )}
          content={this.renderStatementPeriodDialogContent()}
          positiveButtonLabel={this.trans('button-continue')}
          negativeButtonLabel={this.trans('button-cancel')}
          openLeavePrompt={this.state.isChangeStatementPeriodPopupOpen}
          prioritizeClosing={true}
          onDiscard={() =>
            this.setState({ isChangeStatementPeriodPopupOpen: false })
          }
          onSave={this.updateStatementPeriod.bind(this, charge)}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }

}
